module.exports = __webpack_public_path__ + "img/pic_app_banner.353b7587.jpg";